module.exports = __webpack_public_path__ + "static/media/holeriteIcon.2441ccdf.svg";